import styled from "styled-components";

export const Compatible = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.9);
`;

export const CompatibleMsg = styled.div`
  background-color: white;
  width: 600px;
  padding: 20px 30px;
  font-size: 16px;
  color: #000;
  line-height: 14px;
  text-align: center;
  border-radius: 20px;
`;
